/*-------------- Cart + Checkout Custom JS --------------------
Prepared by BentoSMB Inc in August 2019
Code is used to heavily modify the cart and checkout process for NGC's delivery dates,
loan, credit score, and payment systems. This is primarily functions, actuall implementation
code iwll reside in the page or in seperate script sets.
---------------------------------------------------------------*/

//Constants

const weeksToShow = 2; //weeks in advance to show in the delivery date picker
const installProduct = 4216127094895;

// --- inventoryLookup.js ---
// Mimics your old Kloudgin API but uses /assets/inventory.json

async function localItemAvailability(customerID, SKUArray) {
  // fetch JSON once and reuse
  if (!window._inventoryData) {
    const res = await fetch('//naturalgasconnection.com/cdn/shop/t/60/assets/inventory.json?v=69258820349735824901778101888');
    window._inventoryData = await res.json();
  }
  const data = window._inventoryData;

  // mimic API structure
  const items = [];

  SKUArray.forEach(({ SKU, quantity }) => {
    const match = data.items.find(i => i.sku === SKU);
    if (match) {
      items.push({
        itemSKU: match.sku,
        itemCount: 9999, // treat as “in stock” unless you track counts
        vendor: match.vendor,
        itemLeadDays: match.leadDays || [0,0,0,0,0,0,0],
        installationCost: match.installationCost || 0
      });
    }
  });

  return { recordsCount: items.length, status: "Records Found", statusCode: 0, items };
}

async function isVariantInStock(SKU, handle) {
  // Fetch Shopify product JSON by handle
  const product = await fetch(`/products/${handle}.js`)
    .then(r => (r.ok ? r.json() : null))
    .catch(() => null);
    console.log({SKU, handle, product});

  if (!product) return false;

  const variant = product.variants.find(v => v.sku === SKU);
  console.log('VARIANT', {variant});
  if (!variant) return false;

  return !!(variant.available);
}

//---------------CART+ CHECKOUT FUNCTIONS--------------

$.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                    .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : false;
}

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function isOdd(num) { return (num % 2) == 1;}

function addDays(date, days) {
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    return date;
}

async function firstPickupDeliveryDates(customerID, SKUArray) {
  return new Promise(async (resolve, reject) => {
    console.log("Starting Local KG Lookup");

    let pickupDatePrint, deliveryDatePrint;
    let inInventory = false;
    let instock = false;

    try {
      const data = await localItemAvailability(customerID, SKUArray);
      console.log("Local Data: ", data);

      if (data.items.length > 1) {
        console.log("More than one item in array");

        const cartPickupDates = [];
        const cartDeliveryDates = [];

        for (let i = 0; i < data.items.length; i++) {
          const currentSKU = data.items[i].itemSKU;
          const currentHandle = SKUArray.find(item => item.SKU === currentSKU)?.handle;
          const foundSKU = SKUArray.find(item => item.SKU === currentSKU);
          console.log('HELLOOOO', {currentHandle, foundSKU, SKUArray});
          const SKUquantity = foundSKU?.quantity || 1;

          // Use Shopify inventory availability
          instock = await isVariantInStock(currentSKU, currentHandle);
          inInventory = true;

          const dateArray = data.items[i].itemLeadDays || [0, 0, 0, 0, 0, 0, 0];
          const dates = itemFirstPickupDeliveryDates(instock, dateArray);

          cartPickupDates.push(dates[0]);
          cartDeliveryDates.push(dates[1]);

          console.log("Cart Item:", currentSKU, instock, dates[0], dates[1]);
        }

        var pickupDate = new Date(Math.max.apply(null, cartPickupDates));
        var deliveryDate = new Date(Math.max.apply(null, cartDeliveryDates));
      } else if (data.items.length > 0) {
        inInventory = true;
        const item = data.items[0];
        const SKUquantity = SKUArray[0].quantity;
        const currentSKU = item.itemSKU;
        const currentHandle = SKUArray[0].handle;

        console.log('HELLOOOO', {currentHandle, SKUArray});

        // Shopify stock check
        instock = await isVariantInStock(currentSKU, currentHandle);

        const dateArray = item.itemLeadDays || [0, 0, 0, 0, 0, 0, 0];
        const dates = itemFirstPickupDeliveryDates(instock, dateArray);
        pickupDate = dates[0];
        deliveryDate = dates[1];
      } else {
        resolve({ error: 1, reason: "Not in inventory. Please check SKU and try again" });
        return;
      }

      // Adjust for weekends
      const adjustDate = date => {
        if (date.getDay() === 0) date.setDate(date.getDate() + 1);
        else if (date.getDay() === 6) date.setDate(date.getDate() + 2);
      };

      adjustDate(pickupDate);
      adjustDate(deliveryDate);

      pickupDatePrint =
        pickupDate.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        pickupDate.toLocaleDateString("en-US", { day: "2-digit" }) +
        "-" +
        pickupDate.toLocaleDateString("en-US", { year: "numeric" });

      deliveryDatePrint =
        deliveryDate.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        deliveryDate.toLocaleDateString("en-US", { day: "2-digit" }) +
        "-" +
        deliveryDate.toLocaleDateString("en-US", { year: "numeric" });

      // Add friendly messaging for out-of-stock
      if (!instock) {
        console.warn("Item is currently out of stock. Please contact Sales for accurate lead times.");
      }

      console.log("pickupDate:", pickupDatePrint, "deliveryDate:", deliveryDatePrint);
      resolve({
        pickupDate: pickupDatePrint,
        deliveryDate: deliveryDatePrint,
        instock,
        message: instock
          ? "In stock and ready to ship"
          : "Currently out of stock — please contact Sales for accurate lead times."
      });
    } catch (error) {
      console.error("Local lookup failed", error);
      resolve({ error: 1, reason: "Lookup failed" });
    }
  });
}

function itemFirstPickupDeliveryDates(instock, daysArray) {

    //this function will use the settings from the theme, the current date
    //and the KG API call to determine the first available delivery date

    //set variables
    var inStockDays = 0;
    var outStockDays = 0;
    var allDays = 0;
  
    var pickupDays = 0;
    var deliveryDays = 0;
    var d = new Date(); //today, right now

    //if not in stock, determine day of week and get lead days from array
    if ( instock == true ) {

        //instock

        //set pickup and delivery days, push pickup to next day if past 5pm ET
        var todayHours = new Date().getHours();
        if ( todayHours >= 17 ) {
            pickupDays = 1;
        } else {
            pickupDays = 0;
        }
        deliveryDays = inStockDays + allDays;
       
    } else {

        //out of stock

        //calculate the lead time for receiving into stock
        var dayOfWeek = parseInt(d.getDay());
        dayOfWeek = dayOfWeek - 1;

        if ( dayOfWeek == -1 ) { dayOfWeek = 6; };

        var leadDays = daysArray[dayOfWeek]; //lead days from array

        //set pickup and delivery dates based on lead time
        pickupDays = leadDays;
        deliveryDays = leadDays + outStockDays + allDays;

    }
  

    //add the days
    var date = new Date();
    
    var pickupDate = addDays(date, pickupDays);
    var deliveryDate = addDays(date, deliveryDays);

    //determine if either of these dates are in the blackout dates
    var blackoutDates = ["2020-03-16","2020-03-17","2020-03-20","2020-03-26"];
    console.log("Blackout days -> ", blackoutDates);
    var blackoutDay;
    var pickupDate_converted;
    var deliveryDate_converted;

    for (d=0; d < blackoutDates.length; d++ ){
        
        console.log("Blackout day -> ", blackoutDates[d]);

        //convert pickup and delivery date to YYYY-MM-DD format. Needs to be done in the loop for dates back to back
        pickupDate_converted = formatDate(pickupDate);
        console.log("pickup date -> ", pickupDate_converted);
        deliveryDate_converted = formatDate(deliveryDate);
        console.log("pickup date -> ", deliveryDate_converted);

        //check and add a day if needed. Dates in order will be handled via the loop
        if ( blackoutDates[d] == pickupDate_converted ) {
            console.log("Adding date to pickup");
            pickupDate = addDays(pickupDate_converted, 2);
        }

        if ( blackoutDates[d] == deliveryDate_converted ) {
            console.log("Adding date to delivery");
            deliveryDate = addDays(deliveryDate_converted, 2);
        }

    }
  
    //return
    return [ pickupDate, deliveryDate ];

}

function pickupLocation(jurisdiction) {

    var jurisdictionArray = JSON.parse($('meta[name=jurisdictions]').attr("content"));

    var jurisdictionData = jurisdictionArray.filter(obj => {
        return obj.jurisdiction.toLowerCase() == jurisdiction
    })

    console.log("Jurisdiction Details: ", jurisdictionData[0]);
    return jurisdictionData[0];
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

//---------------CART SPECIFIC FUNCTIONS--------------

function checkoutLocal(event) {
    var jurData = pickupLocation(custJurisdiction);

    $('.inner-box.pickup .address').html(jurData.address + "<br>" + jurData.city + ", " + jurData.zip);
    $('.inner-box.pickup .open-time').html(jurData.hours);
    $('.inner-box.pickup .jurisdiction').html(jurData.jurisdiction);

    //show the modal
    showModal('pickup');
    
}

function checkoutInstall(event) {
    showModal('install');
}

function nextStep(type) {

    if (type == 'approve-install') {
        $('#modal .inner-box.install .replacing-appliances').slideToggle(200);
        $('#modal .inner-box.install .approve-install').slideToggle(200);
    } else  if (type == 'custom-install') {
        $('#modal .inner-box.install .replacing-appliances').slideToggle(200);
        $('#modal .inner-box.install .custom-install').slideToggle(200);

    }


}

function requestQuote() {

    //show the spinner
    $('#modal .inner-box.install .custom-install .request').slideToggle(200);
    $('#modal .inner-box.install .custom-install .pending').slideToggle(200);

    //get the full cart JSON object
    var cartJSON = {};
    $.ajax({
        type: "GET",
        url: "/cart.js",
        success: function(data) {
            createDraftAPICall(data);
        },
        error : function(data) {
            $('#modal .inner-box.install .custom-install .pending').slideToggle(200);
            $('#modal .inner-box.install .custom-install .error').slideToggle(200);
        }
    });

}

function createDraftAPICall(data) {

    //fire the call to our API
    $.ajax({
        async: true,
        crossDomain: true,
        type: "POST",
        url: "https://api.naturalgasconnection.com/v1/api/orders/create-draft",
        headers: {
            "customertoken": customerToken
        },
        contentType: "application/json",	
        dataType: 'json',
        data: data,
        success: function(returndata) {
            $('#modal .inner-box.install .custom-install .pending').slideToggle(200);
            $('#modal .inner-box.install .custom-install .complete').slideToggle(200);
        },
        error: function(returndata) {
            $('#modal .inner-box.install .custom-install .pending').slideToggle(200);
            $('#modal .inner-box.install .custom-install .error').slideToggle(200);
        }
    });

}

function addInstallation(amount) {

    //function to add the installation product and proceed to checkout.
    //amount is the $ amount of the installation

    //Show spinner
    $('#modal .inner-box.install .approve-install .request').slideToggle(200);
    $('#modal .inner-box.install .approve-install .pending').slideToggle(200);

console.log (amount)
      console.log(31860586709103)
      
    //add the install to the cart
    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
            updates: {
               31860586709103: amount
            }
        },
        success: function(data) {
            //redirect to checkout
            //window.location.href = "/checkout?step=contact_information";

            //submit the form on this page
            proceedToCheckout(false);
        },
        error : function(data) {
            
        }
    });


}

function proceedToCheckout(pickup) {
    //document.getElementById("cart_form").submit();
    if (pickup == true ) {

        //check if install is added to the cart and delete it, then proceed. 
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
                updates: {
                   31860586709103: 0
                }
            },
            success: function(data) {
                //redirect to checkout
                //window.location.href = "/checkout?step=contact_information";
    
                //submit the form on this page
                $('form#cart_form input#checkout').click();
            },
            error : function(data) {
                
            }
        });

    } else {
        $('form#cart_form input#checkout').click();
    }
}

function showModal(type) {

    //show the overlay and stop scroll
    $('#modal').fadeTo(300,1);
    $('body').css("overflow: hidden");

    //show the right modal based on button choice
    if (type == 'pickup') {
        $('#modal .inner-box.pickup').slideToggle(400);
    } else {
        $('.initial-hide').hide();

        //check cart tags to see if we should just proceed to custom

        if (customInstall == false ) {
            $('.replacing-appliances').show();
            $('#modal .inner-box.install .custom-install .request').show();
            $('#modal .inner-box.install .custom-install .pending').hide();
            $('#modal .inner-box.install .custom-install .complete').hide();
            $('#modal .inner-box.install .custom-install .error').hide();
            $('#modal .inner-box.install').slideToggle(400);

        } else {
            $('#modal .inner-box.install .replacing-appliances').hide();
            $('#modal .inner-box.install .custom-install .pending').hide();
            $('#modal .inner-box.install .custom-install .complete').hide();
            $('#modal .inner-box.install .custom-install .error').hide();
            $('#modal .inner-box.install .custom-install').slideToggle(200);
            $('#modal .inner-box.install').slideToggle(400);

        }
        
    }
    
}

function hideModal(type) {

    //hide the right modal when called.
    if (type == 'pickup') {
        $('#modal .inner-box.pickup').slideToggle(400);
    } else {
        $('#modal .inner-box.install').slideToggle(400);
    }

    //set the body back to scroll and hide the overlay
    $('body').css("overflow: visible");
    $('#modal').fadeOut(300,0);
}

async function installCost(customerID, SKUArray) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await localItemAvailability(customerID, SKUArray);
      console.log("Local Data: ", data);

      let installTotal = 0;

      // Calculate total install cost
      for (let i = 0; i < SKUArray.length; i++) {
        const sku = SKUArray[i].SKU;
        const quantity = SKUArray[i].quantity;

        const foundSKU = data.items.find(item => item.itemSKU === sku);
        const cost = foundSKU?.installationCost || 0;

        installTotal += quantity * cost;
      }

      console.log("Total install cost:", installTotal);
      resolve(installTotal);
    } catch (error) {
      console.error("Lookup failed", error);
      resolve(0);
    }
  });
}


//---------------CHECKOUT SPECIFIC FUNCTIONS-----------

function changeToSidebar() {

    //Runs when the sidebar is changed. Make sure we operate our stuff when it changes

    //Remove Shipping line, any discount tags
    if( $('tr.total-line.total-line--shipping').length ) {
        $('tr.total-line.total-line--shipping').remove();
    }
 
    // Remove Gift Card Tag
    if ( $('div.tags-list').length ) {
        $('div.tags-list').remove();
    }

    //find installation product and remove it from products, adjust subtotal. 
    if ( $('tr[data-product-id="' + installProduct + '"]').length ) {
    console.log("Removing Install Item");
    var installTotal = $('tr[data-product-id="' + installProduct + '"] td.product__price span.order-summary__emphasis').html();
    $('tr[data-product-id="' + installProduct + '"]').remove();

    //insert installation above subtotal
    var htmlToInsert = `<tr class="total-line total-line--installtion">
            <th class="total-line__name" scope="row">Delivery + Installation</th>
            <td class="total-line__price">
                <span class="order-summary__emphasis" data-checkout-subtotal-price-target="` + (installTotal*100) + `">
                ` + installTotal + `
                </span>
            </td>
            </tr>`;
            
    $(htmlToInsert).insertBefore('tr.total-line.total-line--subtotal');

    //adjust subtotal
    //const subtotal = ($('tr.total-line.total-line--subtotal td.total-line__price span').attr("data-checkout-subtotal-price-target")/100) - installTotal;
    //$('tr.total-line.total-line--subtotal td.total-line__price span').attr("data-checkout-subtotal-price-target", (subtotal * 100 ) ).html("$" + subtotal.toFixed(2));

    }

    //check for gift card lines and modify text
    if ( $('tr[data-giftcard-success]').length) {
    console.log("Adjusting Gift Card");
    const gcTotal = parseInt($('tr[data-giftcard-success] td.total-line__price span.order-summary__emphasis').attr('data-checkout-applied-gift-card-amount-target'));
    console.log(gcTotal);
    var gchtmlToInsert = `<tr class="total-line total-line--reduction">
        <th class="total-line__name" scope="row">
            <span>Financing</span>
        </th>
        <td class="total-line__price">
            <span class="order-summary__emphasis" data-checkout-applied-gift-card-amount-target="` + gcTotal +`">
            - $` + (gcTotal/100).toFixed(2) + `
            </span>
        </td>
        </tr>`
    $(gchtmlToInsert).insertBefore('tr[data-giftcard-success]');
    $('tr[data-giftcard-success]').remove();
    }

    //show the main sidebar
    if ($('.sidebar__content').is(":hidden")) {
    console.log("Showing Sidebar");
    $('.sidebar__content').fadeIn(200);
    $('.sidebarContentPlaceholder').remove();
    }

}

function setupDeliveryDates(startDate, weeks) {

    //each week has 10 choices, AM/PM, M-F. Determine which choices in first week are avaiable
    var date = new Date(startDate)
    var firstDay = date.getDay();
    var firstBlock = (firstDay * 2) - 1;
    var firstBlockDate = addDays(date, (firstDay * -1) + 1);

    //create first week choice blocks
    var htmlToReturn = `<div class="week week-0">`;
    var daysToAdd = 0;

    for (i = 1; i < 11; i++) {

        Date.prototype.addDays = function(days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }

        //determine date for the block
        var actualDaysToAdd = Math.floor(daysToAdd / 2);
        var newdate = addDays(firstBlockDate, actualDaysToAdd);
        daysToAdd ++;
        var blockDate = (newdate.getMonth()+1) + "/" + newdate.getDate() + "/" + newdate.getFullYear();
        var printDay = newdate.toLocaleDateString('en-US', { weekday: 'long'});
        var printDay2 = newdate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

        //determine AM/PM and add to data
        if ( isOdd(i) ) {
            var label = "8 AM - 12PM";
            htmlToReturn += `<div class="column">
                <div class="date-top">
                ` + printDay + `<br>` + printDay2 + `
                </div>
            `;
        } else {
            var label = "12 PM - 4PM";
        }

        if ( i >= firstBlock) {
            
            if ( isOdd(i) ) {
                blockDate += ":AM"
            } else {
                blockDate += ":PM"
            }

            htmlToReturn += `<div class="btn choice selectable" data-date-time="` + blockDate + `">
            ` + label + ` 
            </div>`;
        } else {
            htmlToReturn += `<div class="btn choice not-selectable btn--disabled" disabled>
            ` + label + ` 
            </div>`;
        }

        if ( isOdd(i) ) {
        } else {
            htmlToReturn += `</div>`;
        }
    }

    htmlToReturn += `</div>`;

    //create additional weeks blocks
    for (j = 1; j <= weeks; j++) {
        htmlToReturn += `<div class="week week-` + j + `" style="display: none">`;
        daysToAdd = daysToAdd + 4; //2 days, 4 blocks
        for (k = 1; k < 11; k++) {

            //determine date for the block
            var actualDaysToAdd = Math.floor(daysToAdd / 2);
            var newdate = addDays(firstBlockDate, actualDaysToAdd);
            daysToAdd ++;
            var blockDate =  (newdate.getMonth()+1) + "/" + newdate.getDate()+ "/" + newdate.getFullYear();
            var printDay = newdate.toLocaleDateString('en-US', { weekday: 'long'});
            var printDay2 = newdate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

            if ( isOdd(k) ) {
                var label = "8 AM - 12PM";
                blockDate += ":AM"
                htmlToReturn += `<div class="column">
                <div class="date-top">
                ` + printDay + `<br>` + printDay2 + `
                </div>
            `;
            } else {
                var label = "12 PM - 4PM";
                blockDate += ":PM"
            }
    
            htmlToReturn += `<div class="btn choice selectable" data-date-time="` + blockDate + `">
            ` + label + ` 
            </div>`;

            if ( isOdd(k) ) {
            } else {
                htmlToReturn += `</div>`;
            }
        }
        htmlToReturn += `</div>`;
    }

    //add previous/next week buttons if multiple weeks
    if ( weeks > 0 ) {

        htmlToReturn += `
            <div class="pagination">
                <div class="prev btn choice" style="display: none">Previous Week</div>
                <div class="next btn choice">Next Week</div>
            </div>
        `;

    }

    $('.delivery-dates-widget').html(htmlToReturn);

    //check the blackout dates and set proper disable
    var blackoutDates = ["2020-03-16","2020-03-17","2020-03-20","2020-03-26"];
    console.log("Blackout days -> ", blackoutDates);
    var blackoutDay;

    for (d=0; d < blackoutDates.length; d++ ){
        
        //convert the date to the right format
        var date = new Date(blackoutDates[d]),
            month = '' + (date.getMonth() + 1),
            day = '' + (date.getDate() + 1),
            year = date.getFullYear();

        blackoutDay = [month, day, year].join('/');
        console.log("blackoutDay formatted dd/mm/yyyy -> ", blackoutDay);
        
        //add the AM and PM, then set those to disabled if they exist.
        $('div.delivery-dates-widget div.btn.choice[data-date-time="' + blackoutDay + ':AM"]').addClass("not-selectable btn--disabled").removeClass("selectable").attr("disabled", true);
        $('div.delivery-dates-widget div.btn.choice[data-date-time="' + blackoutDay + ':PM"]').addClass("not-selectable btn--disabled").removeClass("selectable").attr("disabled", true);

    }
}

function insertDeliverDatesToForm(dateArray) {

    console.log("updateing form field delivery date");

    //format the array for insert
    var returnValue = "";
    var formattedDatesReturn = "";

    for (i = 0; i < dateArray.length; i++) {
        var optionNum = i + 1;
        returnValue += "Option " + optionNum + ` - ` + dateArray[i] + `, `;
        formattedDatesReturn += "Option " + optionNum + ` - ` + dateArray[i].replace(":", ", ").replace("AM", "8am-12pm").replace("PM", "12pm-4pm") + `</br>`;
    }

    //kill the final comma and space
    returnValue = returnValue.slice(0, -2);
    formattedDatesReturn = formattedDatesReturn.slice(0, -5);

    //insert it into the form, replace if already there
    if ( $('input#delivery-dates').length) {
        //already inserted, update value
        $('input#delivery-dates').attr('value', returnValue);

    } else {
        //not yet inserted, insert the whole input field

        //set the field to return
        var fieldToInsert = `<input hidden id="delivery-dates" type="text" name="checkout[attributes][Chosen Delivery Dates]"
        value="` + returnValue + `" />`
        $(fieldToInsert).insertAfter('div.step__footer');
    }

    //update the customer data field at top of page regardless.
    if (formattedDatesReturn == "") { formattedDatesReturn = "To Be Determined" };
    $('div.row.delivery-details .content').html(formattedDatesReturn);

}

function insertFirstDeliveryDateToForm(date) {

    console.log("adding first delivery date to form");

    //format the array for insert
    var returnValue = date;

    console.log(returnValue);

    //insert it into the form, replace if already there
    if ( $('input#first-delivery-date').length) {
        //already inserted, update value
        $('input#first-delivery-date').attr('value', returnValue);

    } else {
        //not yet inserted, insert the whole input field

        //set the field to return
        var fieldToInsert = `<input hidden id="first-delivery-date" type="text" name="checkout[attributes][First Available Delivery Date]"
        value="` + returnValue + `" />`
        $(fieldToInsert).insertAfter('div.step__footer');
    }

}

function clearDeliveryDates() {
    //function to clear all delivery dates and refresh page if needed

    //clear any selected dates
    $('.btn.choice.selectable.selected').each(function() {
        //remove the class
        $(this).click();
    });

    //deliveryDates.splice(0,3);

    /*
    $('.step__footer__continue-btn span').html("Select Dates To Continue");
    $('.step__footer__continue-btn').attr("disabled", true).addClass('btn--disabled');

    insertDeliverDatesToForm([]);
    */

}

function transitionSections(idToHide, idToShow) {

    $('div#'+ idToHide).fadeOut( 300, function() {
        $('div#' + idToShow).slideDown(300, function() {
            console.log("WQOEQWIEJQWOIEJ");
            console.log('$(this)', $(this))
            return;
        });
    });

}

function transitionToCredit(idToHide) {

    $('div#'+ idToHide).fadeOut( 300, function() {
        $('div.section--payment-method').show();
        $('.step__footer').show();
        $('form.edit_checkout').slideDown(300);
    });

}

async function lookupCreditScoreRecheck() {
    $('div#financing-step-3-1').fadeOut( 300, function() {
        $('div#financing-step-2').slideDown(300, async function() {
            //get the financing details
            var financingDetails = await getFinancingDetails(true);
			console.log("financingDetails", financingDetails);
            //deal with the results
            if ( financingDetails.offerFinancing == "yes" ) {

                if ( loanAmount > 0 ){

                    if (loanAmount / 100 < loanMaxAmount) {
                        loanMaxAmount = Math.min(Math.max(loanMaxAmount - ( loanAmount / 100 ), 0), loadMaxAmount);
                    }

                    var htmlToAdd = `
                        <h3>Step 3 - Loan Approval/Decline</h3>
                        <div class="step-container">
                            <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                            <h3>You Are Approved!</h3>
                            <p>Based on your credit score, previous loan amounts and cart total, you are approved for up to $` + loanMaxAmount + ` in loans for your purchase.</p>
                            <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                            <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                        </div>
                    `

                    if ( loanMax > loanMaxAmount ) {
                        loanMax = loanMaxAmount;
                    }

                } else {

                    var htmlToAdd = `
                        <h3>Step 3 - Loan Approval/Decline</h3>
                        <div class="step-container">
                            <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                            <h3>You Are Approved!</h3>
                            <p>Based on your credit score and cart total, you are approved for up to $` + loanMaxAmount + ` in loans for your purchase.</p>
                            <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                            <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                        </div>
                    `

                    if ( loanMax > loanMaxAmount ) {
                        loanMax = loanMaxAmount;
                    }

                }
                

                setupLoanCalculator();

            } else if ( financingDetails.offerFinancing == "conditional" ) {

                if ( loanMax > ((loanMaxAmount * ( 100 - loanDownpayment)) / 100 ).toFixed(2) ) {
                    loanMax = ((loanMaxAmount * ( 100 - loanDownpayment)) / 100 ).toFixed(2);
                } else {
                    loanMax = financingDetails.offerMaxAmount;
                }

                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                        <h3>You Are Approved!</h3>
                        <p>Based on your credit score and cart total, you are approved for up to $` + loanMax + ` in loans for your purchase. A ` + loanDownpayment + `% downpayment is required at checkout with a credit/ debit card or you can pay in person at your city’s utility payment center.</p>
                        <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                    </div>
                `
                setupLoanCalculator();

            } else if ( financingDetails.offerFinancing == "no") {
                
                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <h3 style="margin: 30px 0px;">Your Application has been Declined</h3>
                        <p>Based on your credit score, we are not able to offer you financing at this time. Please contact us if you feel this is an error. Otherwise please proceed with credit card payment.</p>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Back To Payment Options</div>
                    </div>
                `

            } else {
                
                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <h3 style="margin: 30px 0px;">We were unable to obtain your credit score.</h3>
                        <p>At this time, we were still not able to get your credit score. Please contact us if you feel this is an error. Otherwise please proceed with credit card payment.</p>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Back To Payment Options</div>
                    </div>
                `

            }

            $('#financing-step-3').html(htmlToAdd);
            transitionSections('financing-step-2', 'financing-step-3');
        })
    })
}

async function lookupCreditScore() {

    //transition to the loading screen
    $('div#financing-step-1').fadeOut( 300, function() {
        $('div#financing-step-2').slideDown(300, async function() {

            //get the financing details
            var financingDetails = await getFinancingDetails();
			console.log("financingDetails", financingDetails);
            //deal with the results
            if ( financingDetails.offerFinancing == "yes" ) {

                if ( loanAmount > 0 ){

                    if (loanAmount / 100 < loanMaxAmount) {
                        loanMaxAmount = Math.min(Math.max(loanMaxAmount - ( loanAmount / 100 ), 0), loadMaxAmount);
                    }

                    var htmlToAdd = `
                        <h3>Step 3 - Loan Approval/Decline</h3>
                        <div class="step-container">
                            <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                            <h3>You Are Approved!</h3>
                            <p>Based on your credit score, previous loan amounts and cart total, you are approved for up to $` + loanMaxAmount + ` in loans for your purchase.</p>
                            <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                            <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                        </div>
                    `

                    if ( loanMax > loanMaxAmount ) {
                        loanMax = loanMaxAmount;
                    }

                } else {

                    var htmlToAdd = `
                        <h3>Step 3 - Loan Approval/Decline</h3>
                        <div class="step-container">
                            <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                            <h3>You Are Approved!</h3>
                            <p>Based on your credit score and cart total, you are approved for up to $` + loanMaxAmount + ` in loans for your purchase.</p>
                            <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                            <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                        </div>
                    `

                    if ( loanMax > loanMaxAmount ) {
                        loanMax = loanMaxAmount;
                    }

                }
                

                setupLoanCalculator();

            } else if ( financingDetails.offerFinancing == "conditional" ) {

                if ( loanMax > ((loanMaxAmount * ( 100 - loanDownpayment)) / 100 ).toFixed(2) ) {
                    loanMax = ((loanMaxAmount * ( 100 - loanDownpayment)) / 100 ).toFixed(2);
                } else {
                    loanMax = financingDetails.offerMaxAmount;
                }

                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                        <h3>You Are Approved!</h3>
                        <p>Based on your credit score and cart total, you are approved for up to $` + loanMax + ` in loans for your purchase. A ` + loanDownpayment + `% downpayment is required at checkout with a credit/ debit card or you can pay in person at your city’s utility payment center.</p>
                        <div class="btn payment-option financing" onclick="transitionSections('financing-step-3', 'financing-step-4')">Choose Options</div>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                    </div>
                `
                setupLoanCalculator();

            } else if ( financingDetails.offerFinancing == "no") {
                
                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <h3 style="margin: 30px 0px;">Your Application has been Declined</h3>
                        <p>Based on your credit score, we are not able to offer you financing at this time. Please contact us if you feel this is an error. Otherwise please proceed with credit card payment.</p>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Back To Payment Options</div>
                    </div>
                `

            } else {
                
                var htmlToAdd = `
                    <h3>Step 3 - Loan Approval/Decline</h3>
                    <div class="step-container">
                        <h3 style="margin: 30px 0px;">We were unable to obtain your credit score.</h3>
                        <p>If you feel this is an error, please review. If you have recently moved, this could potentially be the reason we could not obtain your credit score. Please update your information with your previous home address to try again. Otherwise, please proceed with a credit card payment.</p>
                        <div class="btn outline payment-option credit" onclick="transitionSections('financing-step-3', 'financing-step-3-1')">Update Details and Try Again</div>
                        <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Back To Payment Options</div>
                    </div>
                `

            }

            $('#financing-step-3').html(htmlToAdd);
            transitionSections('financing-step-2', 'financing-step-3');

            return;

        });
    });
    
}

function getFinancingDetails(recheck) {

    return new Promise(function(resolve, reject) {
        //Call our API, then determine the actual financing offerings based on settings/threshold
      if (testCust){
        console.log("testCust", testCust);
      }
      if (recheck) {
        testJSON.recheck = true;
        testJSON.address1 = $('#recheck-address').val();
        testJSON.city = $('#recheck-jurisdiction').val();
        testJSON.province_code = $('#recheck-state').val();
        testJSON.zip = $('#recheck-zip').val();
    }
      console.log("testJSON", testJSON);
        $.ajax({
            async: true,
            crossDomain: true,
            type: "POST",
            url: "https://api.naturalgasconnection.com/v1/api/checkout/credit-score",
            headers: {
                "customertoken": customertoken
            },
            data: JSON.stringify(testJSON),
            success: function(data) {
                //API call will return a match/nomatch and a score if matched
                console.log("Credit Score is: " + data.score);

                var toReturn;
                

                //determine if we will offer financing "offerFinancing": "no"/"yes"/"conditional"
                if (data.score >= maxScore ) {
                    toReturn = { "offerFinancing": "yes", "offerMaxAmount": loanMax }
                } else if (data.score >= minScore ) {
                    toReturn = { "offerFinancing": "conditional", "offerMaxAmount": ((loanMax * ( 100 - loanDownpayment)) / 100 ).toFixed(2)}
                } else {
                    toReturn = { "offerFinancing": "no", "offerMaxAmount": 0 }
                }

                //testing
                

                //return to the calling function
                resolve(toReturn);
            },
            error: function(err) {

            }
        })
    });

}

//initiallize Slider function
function initSlider(id,max,start,step,fixed) {
    $( "#" + id ).slider({
        change: function( event, ui) {
            console.log((ui.value).toFixed(fixed));
        },
        slide: function( event, ui) {
            $('span#' + id + '-total').html((ui.value).toFixed(fixed));
            calculateMonthlyTotal(id,(ui.value).toFixed(fixed));
        },
        range: "min",
        max: max + 0.01,
        value: start,
        step: step
    });

    $('span#' + id + '-total').html(start);
}

function setupLoanCalculator() {

    //init sliders
    initSlider('totalSlider',loanMax,loanMax,0.01,2);
    initSlider('monthSlider',60,48,1,0);

    //init the total cost addition
    calculateMonthlyTotal();

}

function calculateMonthlyTotal(type,value) {

    //determine the total amount based on the slider values
    if (type == "totalSlider") {
        totalAmount = value;
        monthAmount = parseInt($('#monthSlider').slider( "value"));
    } else if (type == "monthSlider") {
        totalAmount = parseFloat($('#totalSlider').slider( "value"));
        monthAmount = value;
    } else {
        totalAmount = parseFloat($('#totalSlider').slider( "value"));
        monthAmount = parseInt($('#monthSlider').slider( "value"));
    }

    loanMonth = parseFloat((totalAmount / monthAmount) + 3).toFixed(2); //add three dollars for the monthly admin fee
    $('#total-amount').html(loanMonth);

}

function loanAdditionalDetails(type) {

    if (type == "ownResidence" ) {
        if (ownResidence == true ) {
            $('.checkbox.ownResidence').removeClass('checked');
            $('input#own-residence').prop( "checked", false );
            ownResidence = false;
            $('#confirm-loan-details').addClass('btn--disabled');
        } else {
            $('.checkbox.ownResidence').addClass('checked');
            $('input#own-residence').prop( "checked", true );
            ownResidence = true;
            $('#confirm-loan-details').removeClass('btn--disabled');
        }
    }

    if (type == "occupyResidence" ) {
        if (occupyResidence == true ) {
            $('.checkbox.occupyResidence').removeClass('checked');
            $('input#occupy-residence').prop( "checked", false );
            occupyResidence = false;
        } else {
            $('.checkbox.occupyResidence').addClass('checked');
            $('input#occupy-residence').prop( "checked", true );
            occupyResidence = true;
        }
    }

    if (type == "rentalProperty" ) {
        if (rentalProperty == true ) {
            $('.checkbox.rentalProperty').removeClass('checked');
            $('input#rental-property').prop( "checked", false );
            rentalProperty = false;
        } else {
            $('.checkbox.rentalProperty').addClass('checked');
            $('input#rental-property').prop( "checked", true );
            rentalProperty = true;
        }
    }

}

function submitLoanDetails() {

    //transition to the full screen spinenr
    $('div#main-checkout-wrap').fadeOut( 300, function() {
        $('div#loan-doc-checkout-wrap').fadeIn(300, async function() {

            //call our API to create the loan document
            var toReturn = createLoanDocument() //returns a promise that resolves to the URL.
            
            .then(function() { //runs after the initial promise resolves

                console.log("iFrame URL: " + iframeURL);

                //setup iFrame and add to DOM
                $('<iframe>', {
                    src: iframeURL,
                    id:  'loanApp',
                    frameborder: 0,
                    scrolling: 'yes',
                    style: "margin: 20px auto; width: 80vw; height: 65vh; border: 1px solid #999; max-width: 1200px"
                    }).appendTo('#loan-iframe-wrap');

                $('<div class="btn" onclick="loanSigned()">I Confirm I Have Signed This Document</div><div class="btn outline" onclick="loanDeclined()">Decline Loan</div>').appendTo('#loan-iframe-wrap');

                //show modal and attach listening events
                $('div#loading-loan-doc').fadeOut( 300, function() {
                    $('div#loan-iframe-wrap').fadeIn(300);
                });

            });

            return toReturn;

        });
    });
}

function createLoanDocument() {

    return new Promise(function(resolve, reject) {

        //setup the content for the call
        var loanDocParams = {
            "customer" : customerObj,
            "own_residence": ownResidence,
            "occupy_residence": occupyResidence,
            "rental_property": rentalProperty,
            "appliances_financed": appliancesFinanced,
            "loan_amount": totalAmount,
            "loan_months": monthAmount,
            "loan_amount_monthly": loanMonth,
            "callbackURL": "https://api.naturalgasconnection.com/v1/api/callback"
        }

        //call API to get the loan document. Note this usually takes 5-15 seconds to process. 

        $.ajax({
            async: true,
            crossDomain: true,
            type: "POST",
            url: "https://api.naturalgasconnection.com/v1/api/checkout/create-contract",
            headers: {
                "customertoken": customertoken,
            },
            data: JSON.stringify(loanDocParams),
            success: function(data) {
                iframeURL = data.iframeURL;
                console.log(iframeURL);
                resolve();
            },
            error: function(err) {
                resolve(err);
            }
        });
    });

}

function loanSigned() {

    

    //Called when the loan is signed in Signing Hub, needs to finalize the checkout
    $('div#loan-iframe-wrap').fadeOut( 300, function() {
        $('div#loading-loan-doc h3').html("Finalizing Your Loan Document. This might take a few seconds.");
        $('div#loading-loan-doc').fadeIn(300);
    });

    //create gift card
    var toReturn = createGiftCard()
    
    //apply said gift card
    .then(function() {
                
        console.log("gift card created, applying and refreshing");

        //Add gift Card Amount and submit - Note this automatically updates the forms but does nto refresh the page
        $('input#checkout_reduction_code').val(giftcardnumber).trigger('change');
        $('.order-summary__section--discount button[type="submit"]').removeClass('btn--disabled').removeAttr("disabled").click();
        
        //refresh the payment page
        setTimeout( function() {
            location.reload();
            //$('div#loading-loan-doc').fadeOut(300);
            //$('div#main-checkout-wrap').fadeIn(300);
        }, 1500)
    })

    return toReturn;

}

function createGiftCard() {

    return new Promise(function(resolve, reject) {

        //Call our API to create a Guft card for this customer and the right amount
        $.ajax({
            async: true,
            crossDomain: true,
            type: "POST",
            url: "https://api.naturalgasconnection.com/v1/api/checkout/create-giftcard",
            headers: {
                "customertoken": customertoken,
            },
            data: JSON.stringify({
                "amount": totalAmount
            }),
            success: function(data) {
                //applyGiftCard("c6cb 5fc8 h64f gg77");
                giftcardnumber = data.code;
                console.log("======== Gift Card Number ========");
                console.log(giftcardnumber);
                resolve();
            },
            error: function(err) {
                resolve(err);
            }
        });

    });
}

function loanDeclined() {
    location.reload();
}

function transitionLoanToCredit() {

    $('div#apply-financing').fadeOut( 300, function() {
        $('div.section--payment-method').show();
        $('form.edit_checkout').slideDown(300);
    });
}

//--------------- General Load of Script --------------

$(window).on('load', async function() {

    var deliveryDates= [];

    //general load of the cart page
    if ($('body#theme').length) {



    }

    //general load of the checkout page
    if ($('body#checkout').length) {

        //--------------------------------------------
        //---------------GENERAL LOAD ----------------
        //--------------------------------------------

        //--------------------------------------------
        //---------------SIDEBAR LOAD ----------------
        //--------------------------------------------

        //watch for and then modify and load the checkouts sidebar
        changeToSidebar();

        //watch for sidebar changes and then make ours to keep things correct
        const sidebarTarget = document.getElementById('main-sidebar');
        const config = { attributes: false, childList: true, subtree: true };
        const callback = function(mutationsList, observer) {
            for(let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    changeToSidebar();
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(sidebarTarget, config);

        //--------------------------------------------
        //---------------MAIN CONTENT LOAD -----------
        //--------------------------------------------

            //--------------------------------------------
            //--------------DELIVERY PAGE LOAD -----------
            //--------------------------------------------
      
            //see if the customer details are present
            if ($('div[data-step="contact_information"]').length ) {

                //hide the account details, don't need to see this but need the content
                $('div.section--contact-information').hide();
                $('div.section--shipping-address').hide();
                $('div.section--billing-address').hide();

                //seelct the right address
                let properties = {};
                try {
                  properties = JSON.parse($('#checkout_shipping_address_id option:first').attr('data-properties'));
                } catch {
                  properties = {};
                }
                console.log("======= Customer Detatils ===========");
                console.log(properties);

                setTimeout(function() {
                    $('#checkout_shipping_address_id').val($("#checkout_shipping_address_id option:first").val());
                    $('#checkout_shipping_address_first_name').val(properties.first_name);
                    $('#checkout_shipping_address_last_name').val(properties.last_name);
                    $('#checkout_shipping_address_address1').val(properties.address1);
                    $('#checkout_shipping_address_address2').val(properties.address2);
                    $('#checkout_shipping_address_city').val(properties.city);
                    $('#checkout_shipping_address_zip').val(properties.zip);
                    $('#checkout_shipping_address_province').val(properties.province_code)

                }, 1000 );
                

                $('li.delivery-pickup a').addClass("current");
                $('#clear-dates-btn').show();
    
                //if we are doing a delivery for this order, we need to get dates

                console.log("Delivery = ", delivery);

                if ( delivery == true ) {
                var htmlToInsert = `<div class="delivery-dates">
                    <h2 class="section__title">Delivery + Installation</h2>
                    <p>Delivery and installation of your new appliances is included in the cost of the products. Please select the date and time you would prefer to have the items delivered and installed, along with up to 2 alternative days and times. We will contact you to confirm the final date and a more specific time frame within 72 hours of finalizing your order.</p>
                    <div class="delivery-dates-widget">
                    <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/green-ajax-spinner.svg?v=145941588759123521101778101888" width="100px""></div>
                    <h3>Fetching Available Delivery Dates</h3>
                    </div>
                </div>`
    
                //set the continue button to data selection
                $('.step__footer__continue-btn span').html("Select Dates To Continue");
                $('.step__footer__continue-btn').attr("disabled", true).addClass('btn--disabled');
                } else {
                var firstDateObject = await firstPickupDeliveryDates(customerID, SKUArray);
                var jurData = pickupLocation(custJurisdiction) || {};

                var htmlToInsert = `<div class="delivery-dates">
                    <h2 class="section__title">Picking Up Your Order</h2>
                    <p>This order will be available for pickup on ` + firstDateObject.pickupDate + ` from the following address:</p>
                    <p>` + jurData.address + `, ` + jurData.city + `, Georgia, ` + jurData.zip + `</p>
                    <p>` + jurData.hours + `</p>
                </div>`
                }
    
                $('button.step__footer__continue-btn span.btn__content').html("Continue to Payment");
    
                $(htmlToInsert).insertAfter('div.contact-information');
    
                $('div.step').slideDown(200);
                $('.layoutContentPlaceholder').remove();
    
                //--------------------------------------------
                //------------DELIVERY DATE WIDGET------------
                //--------------------------------------------

                //if dates are already selected and stored, preselect them
                //handled in the liquid exceptions area of the checkout, see header.

                var firstDateObject = await firstPickupDeliveryDates(customerID, SKUArray);
                var firstDate = firstDateObject.deliveryDate;

                console.log("First Date: ", firstDate);

                insertFirstDeliveryDateToForm(firstDate);

                //set all of the elements up and show to user
                setupDeliveryDates(firstDate,weeksToShow);

                //add selected classes and set the right number of selected dates if they exist
                if ( dates.length > 0 ) {
                    $('.step__footer__continue-btn span').html("Continue To Payment/Financing");
                    $('.step__footer__continue-btn').attr("disabled", false).removeClass('btn--disabled');

                    var deliveryDates = formattedDates;
                    console.log(deliveryDates);

                    for( var i = 0; i < dates.length; i++){ 
                        $('div[data-date-time="' + dates[i] + '"]').addClass('selected');
                    }

                    insertDeliverDatesToForm(deliveryDates);

                };

                //allow selection of dates
                $('.btn.choice.selectable').click(function() {
                    
                    //check if this element also has selected class
                    if ($(this).hasClass('selected')) {
                        //remove the class
                        $(this).removeClass('selected');

                        //remove from the array of dates
                        for( var i = 0; i < deliveryDates.length; i++){ 
                            if ( deliveryDates[i] == $(this).attr('data-date-time')) {
                                deliveryDates.splice(i, 1); 
                            }
                        }
                        console.log(deliveryDates);

                    } else {

                        //check array is no more then 3
                        if ( deliveryDates.length > 2 ) {

                            //inform user you can only select 3
                            alert('3 date/times have already been selected. Please choose up to 3 different delivery/install timeframes.');

                        } else {

                            //add class
                            $(this).addClass('selected');

                            //add to array
                            deliveryDates.push($(this).attr('data-date-time'));
                            console.log(deliveryDates);

                        }
                        
                    }

                    //check array length, allow use to move forward or not
                    if ( deliveryDates.length > 0) {
                        $('.step__footer__continue-btn span').html("Continue To Payment/Financing");
                        $('.step__footer__continue-btn').attr("disabled", false).removeClass('btn--disabled');
                    } else {
                        $('.step__footer__continue-btn span').html("Select Dates To Continue");
                        $('.step__footer__continue-btn').attr("disabled", true).addClass('btn--disabled');
                    }

                    insertDeliverDatesToForm(deliveryDates);

                });

                //prev/next buttons
                var currentpage = 0;
                $('.pagination .btn').click(function() {

                    //determine if we are going prev or next
                    if ($(this).hasClass('prev')) {
                        console.log("prev button clicked");

                        //go back a page
                        $('.week.week-' + currentpage).fadeOut(100, function() {
                            currentpage = currentpage - 1;
                            $('.week.week-' + currentpage).fadeIn(100);
                            console.log(currentpage);

                            //if page is now 0, hide prev
                            if (currentpage == 0) {
                                $('.pagination .btn.prev').fadeOut(100); 
                            }
                            $('.pagination .btn.next').fadeIn(100);
                            
                        });

                    } else { //move forward a page
                        console.log("next button clicked");

                        //go forward a page
                        $('.week.week-' + currentpage).fadeOut(100, function(){
                            currentpage = currentpage + 1;
                            $('.week.week-' + currentpage).fadeIn(100);
                            console.log(currentpage);
                            
                            //if page is now max pages, hide next
                            if (currentpage == weeksToShow) {
                                $('.pagination .btn.next').fadeOut(100); 
                            }
                            $('.pagination .btn.prev').fadeIn(100);
                        });


                    }
                });

            };

            //--------------------------------------------
            //--------------SHIPPING PAGE LOAD -----------
            //--------------------------------------------

            if ($('div[data-step="shipping_method"]').length ) {

                $('button#continue_button').trigger( "click" ); 

            }

            //--------------------------------------------
            //--------------PAYMENT PAGE LOAD -----------
            //--------------------------------------------

            //see if the customer details are present
            if ($.urlParam('step') == "payment_method" || $('div[data-step="payment_method"]').length ) { 

                //Wait until the taxes are done
                setTimeout( function() {
                    if($('div[data-step="payment_method"]').is(":hidden")) {
                        location.reload();
                    }
                },2000);

                //hide the account details, don't need to see this but need the content
                $('.step__sections .section').hide();
                $('.step__sections form').hide();

                $('li.payment a').addClass("current");
                console.log('loanAmount', loanAmount);
                if ( loanAmount > 50000000000 ) {
                

                    //Add in the HTML we will need
                    var htmlToInsert = `
                    <div class="section payment-start" id="payment-start">
                        <h2 class="section__title">Payment Details</h2>
                        <p>Natural Gas Connection offers two payment methods: financing and credit. As your account has previously already completed the maximum amount of loans available, only credit is available for your purchase.</p>
                        <div class="btn outline payment-option credit" onclick="transitionToCredit('payment-start')">Pay With Credit Card</div>
                    </div>
                    
                    `

                } else {

                    //Add in the HTML we will need
                    var htmlToInsert = `
                    <div class="section payment-start" id="payment-start">
                        <h2 class="section__title">Payment Details</h2>
                        <p>Natural Gas Connection offers two payment methods: financing and credit. Please select from the choice below to move forward.</p>
                        <div class="btn outline payment-option financing" onclick="transitionSections('payment-start', 'apply-financing')">Apply For Financing</div>
                        <div class="btn outline payment-option credit" onclick="transitionToCredit('payment-start')">Pay With Credit Card</div>
                    </div>
                    
                    <div class="section apply-financing" id="apply-financing" style="display: none;">
                        <h2 class="section__title">Apply For Financing</h2>
                        <div class="step0" id="financing-step-0">
                            <p>Zero-interest financing is available to qualified applicants for up to $7,500 for a maximum term of 60 months.  The financed amount will be added to your monthly gas bill and will include a monthly $3 administrative fee.
                            <p style='margin-bottom: 8px;'>By applying for financing, you are certifying the following:</p>
                                <ul style='list-style: disc; padding-left: 32px; margin-bottom: 12px; font-size: .92em;'>
                                    <li>You own the residence in which the appliance will be installed</li>
                                    <li>You authorize Natural Gas Connection to check your credit to determine your creditworthiness
                                    <li>You agree to the monthly loan amount</li>
                                    <li>You will follow all of the Natural Gas Connection Financing Program guidelines</li>
                                </ul>
                            <p>If you are approved, you will be able to select the amount and term of financing.</p>
                            <p><a href="https://cdn.shopify.com/s/files/1/0076/0519/0767/files/How_it_Works_Financing_Portal_FINAL_10K_Loan_Amount.pdf" target="_blank">Click here to view financing guidelines</a></p>
                            <div class="btn payment-option financing" onclick="transitionSections('financing-step-0', 'financing-step-1')">Begin Application</div>
                            <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Back to Payment Options</div>
                        </div>
                        <div class="step1 innitially-hidden financing-step-1" id="financing-step-1">
                            <h3>Step 1 - Credit Score</h3>
                            <p>Natural Gas Connection uses TransUnion to determine your credit score and determine your ability to finance your purchase. By proceeding, you agree to our terms of service and policies surrounding the collection of data for a credit score check.</p>
                            <div class="confirm-credit-check step-container">
                                <div class="confirm-checkbox">
                                    <input type="checkbox" id="confirmed-creditscore" name="confirmed-creditscore" />
                                    <div class="checkbox confirmed-creditscore" ></div>
                                    <label for="confirmed-creditscore">I agree to the policies surrounding the <a href="https://naturalgasconnection.com/pages/privacy-notice" target="_blank" >collection of data</a> and authorize Natural Gas Connection to request my credit score from TransUnion.</label>
                                </div>
                                <div id="authroize-credit" class="btn payment-option financing btn--disabled" onclick="lookupCreditScore()" >Confirm Authorization to Proceed</div>
                                <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Cancel Application</div>
                                <p class="footer">Please note that we do not store the above information in any way and only securely transmit it to our credit score agency TransUnion. More details on this can be found <a href="https://naturalgasconnection.com/pages/privacy-notice" target="_blank">here</a>.</p>
                            </div>
                        </div>
                        <div class="step2 innitially-hidden financing-step-2" id="financing-step-2">
                            <h3>Step 2 - Checking Credit Score</h3>
                            <div class="credit-score-loading step-container">
                                <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/green-ajax-spinner.svg?v=145941588759123521101778101888" width="150px""></div>
                                <h3>Looking Up Your Credit Score</h3>
                            </div>
                        </div>
                        <div class="step3 innitially-hidden financing-step-3" id="financing-step-3">
                        </div>
                        <div class='step3.5 innitially-hidden financing-step-3-1' id="financing-step-3-1">
                            <h3>Step 3 - Loan Approval/Decline</h3>
                            <h3>Adjust your details to try the credit check again.</h3>
                            <p>Please note that you can only perform this second attempt once. If this check fails, you will be required to pay with a credit card or reach out to our support for assistance.</p>
                            <div class='rechecking-input-row'>
                                <input type='text' id='recheck-address' >
                                <input type='text' id='recheck-jurisdiction' >
                            </div>
                            <div class='rechecking-input-row'>
                                <input type='text' id='recheck-state' >
                                <input type='text' id='recheck-zip' >
                            </div>
                            <div class='btn outline' onclick='lookupCreditScoreRecheck()'>Check Score Again</div>
                        </div>
                        <style>
                            .financing-step-3-1{
                                text-align: center;
                            }
                            .financing-step-3-1 > h3{
                                text-align: center;
                                margin-bottom: 18px;
                            }
                            .financing-step-3-1 > p {
                                text-align: center;
                                margin-bottom: 8px;
                            }
                            .rechecking-input-row{
                                display: flex;
                                justify-content: center;
                                gap: 12px;
                                margin-bottom: 14px;
                            }
                            .rechecking-input-row > input {
                                border: 1px solid #cccccc;
                                height: 44px;
                                min-height: 44px;
                                padding: 0 10px;
                                border-radius: 30px;
                                padding-left: 20px;                                
                            }
                        </style>
                        <script>
                            $('#recheck-address').val(customerAddress.address1);
                            $('#recheck-jurisdiction').val(customerAddress.city);
                            $('#recheck-state').val(customerAddress.province);
                            $('#recheck-zip').val(customerAddress.zip);
                        </script>
                        <div class="step4 innitially-hidden financing-step-4" id="financing-step-4">
                            <h3>Step 4 - Choose Loan Options</h3>
                            <p>Please choose the options below for your loan. As you make choices note the amount that will be added to your natural gas utility bill each month. Once confirmed you will be directed to our loan document for digital signature.</p>
                            <div class="loan-calculator step-container">
                                <div class="slider">
                                    <div class="title">Total Loan Amount</div>
                                    <div id="totalSlider"></div>
                                    <div class="slider-total">$<span id="totalSlider-total"></span></div>
                                </div>
                                <div class="slider">
                                    <div class="title">Total Loan Term</div>
                                    <div id="monthSlider"></div>
                                    <div class="slider-total"><span id="monthSlider-total"></span> Months</div>
                                </div>
                                <div class="loan-total">
                                    <div class="title">Monthly Addition</div>
                                    <div class="loan-total-amount">$<span id="total-amount"></span></div>
                                    <div class="subtitle">Includes $3 Monthly Administration Fee</div>
                                </div>
                                <!--<h3 class="title">Additional Details</h3>-->
                                <!--<p>Select All That Apply</p>-->
                                <div class="confirm-checkbox">
                                    <input type="checkbox" id="own-residence" name="own-residence">
                                    <div class="checkbox ownResidence" onclick="loanAdditionalDetails('ownResidence')"></div>
                                    <label for="own-property">I am the owner of this property.</label>
                                    <p style="font-size: 13px; color: #aaa;">Please note that only the homeowner can complete this purchase.  Please call <a phone-number href="tel:1-888-6287-4272" >1-888-6287-4272</a> or email us at <a href="mailto:info@naturalgasconnection.com" >info@naturalgasconnection.com</a> if you’d like further assistance.</p>
                                </div>
                                <!---
                                <div class="confirm-checkbox">
                                    <input type="checkbox" id="occupy-residence" name="occupy-residence">
                                    <div class="checkbox occupyResidence" onclick="loanAdditionalDetails('occupyResidence')"></div>
                                    <label for="occupy-residence">I currently occupy this residence</label>
                                </div>
                                <div class="confirm-checkbox">
                                    <input type="checkbox" id="rental-property" name="rental-property">
                                    <div class="checkbox rentalProperty" onclick="loanAdditionalDetails('rentalProperty')"></div>
                                    <label for="rental-property">This is a rental property.</label>
                                </div> --->
                                <div id="confirm-loan-details" class="btn payment-option btn--disabled" onclick="submitLoanDetails()">Confirm Loan Details</div>
                                <div class="btn outline payment-option credit" onclick="transitionSections('apply-financing', 'payment-start')">Decline Loan</div>
                            </div>
                        </div>
                        <div class="step5 innitially-hidden financing-step-5" id="financing-step-5">
                            <div class="step-container">
                                <div class="spinner"><img class="pending" src="//naturalgasconnection.com/cdn/shop/t/60/assets/approved-financing.png?v=50977222399221822371778101888" width="100px""></div>
                                <h3>Loan Application Completed</h3>`;
                    if (total_price == 0){
                        htmlToInsert += `<p>Your loan application has been approved and completed. A signed copy has been sent to you via email and we have applied a payment to your cart equal to that of the loan. As your financing covers your cart total, we are now redirecting you to the final step to confirm terms and conditions.</p>
                        <div class="btn" onclick="transitionLoanToCredit()">Finalize Checkout</div>`;
                    } else {
                        htmlToInsert += `<p>Your loan application has been approved and completed. A signed copy has been sent to you via email and we have applied a payment to your cart equal to that of the loan. As a balance of ` + total_price_money + ` is due, please complete the rest of the purchase with a credit card.</p>
                        <div class="btn" onclick="transitionLoanToCredit()">Pay Balance With Credit Card</div>`;
                    }
                    htmlToInsert += `
                            </div>
                        </div>
                    </div>`;

                }

                $('.step__sections').prepend(htmlToInsert);

                //look for financing applied, proceed to credit card payment if true
                if ( financing == true ) {

                    //look for and hide any gift card tags
                    //$('div.tags-list .tag').has("input[name^='checkout[applied_gift_cards]']").hide();

                    //setup interface
                    $('div#financing-step-0').hide();
                    $('div#financing-step-5').show();
                    $('div#payment-start').hide();
                    $('div#apply-financing').show();

                }

                $('div.step').slideDown(200, function() {
                    //check if the page is laoded with an error on the cc area and then show the cc area right away
                    if ( $('.notice.notice--error').length > 1 ) {
                        transitionToCredit('payment-start')
                    }
                });
                $('.layoutContentPlaceholder').remove();

                $('.step__footer__previous-link').click( function(event) {
                    event.preventDefault();
                    //$('form.edit_checkout.animate-floating-labels').eq( 0 ).slideUp(300);
                    $('.step__footer').slideUp(300);
                    $('div.section--payment-method').fadeOut( 300, function() {
                        $('div#payment-start').show();
                    });
                })

                /*adjust step 5 text for loans complete
                if (total_price == 0){
                    setTimeout(function() {
                        transitionLoanToCredit()
                    }, 3000);
                }
                */

                //terms and conditions on payment screen + loan approval
                /*
                var terms_html = `<div class="confirm-checkbox">
                            <input type="checkbox" id="confirmed-terms-conditions" name="confirmed-terms-conditions" />
                            <div class="checkbox confirmed-terms-conditions" ></div>
                            <label for="confirmed-terms-conditions">I agree to the <a href="https://cdn.shopify.com/s/files/1/0076/0519/0767/files/Customer_Program_Summary_and_Guidelines.pdf" target="_blank" >terms and conditions</a>.</label>
                        </div>`
                $('.step__footer').prepend(terms_html);
                $('button[data-trekkie-id="complete_order_button"]').addClass('btn--disabled').attr("disabled", true);

                $('.checkbox.confirmed-terms-conditions').click(function() {
                    if ( $('input#confirmed-terms-conditions:checked').length > 0 ) {
                        $('.checkbox.confirmed-terms-conditions').removeClass('checked');
                        $('input#confirmed-terms-conditions').prop( "checked", false );
                        $('button[data-trekkie-id="complete_order_button"]').addClass('btn--disabled').attr("disabled", true);
                    } else {
                        $('.checkbox.confirmed-terms-conditions').addClass('checked');
                        $('input#confirmed-terms-conditions').prop( "checked", true );
                        $('button[data-trekkie-id="complete_order_button"]').removeClass('btn--disabled').attr("disabled", false);
                    }
                });
                */

                //watch for credit check authroization
                $('.checkbox.confirmed-creditscore').click(function() {
                    if ( $('input#confirmed-creditscore:checked').length > 0 ) {
                        $('.checkbox.confirmed-creditscore').removeClass('checked');
                        $('input#confirmed-creditscore').prop( "checked", false );
                        $('#authroize-credit').addClass('btn--disabled').html("Confirm Authorization to Proceed");
                    } else {
                        $('.checkbox.confirmed-creditscore').addClass('checked');
                        $('input#confirmed-creditscore').prop( "checked", true );
                        $('#authroize-credit').removeClass('btn--disabled').html("Authorize Credit Score Review");
                    }
                });
            
            };

            //--------------------------------------------
            //--------------THANK YOU PAGE LOAD ----------
            //--------------------------------------------

            if ($('html.page--thank-you').length ) {

                $('li.complete-order a').addClass("current");

                //insert contact details
                

                //remove the map
                $('.map.default-background').hide();


                //insert financial details
                $('.payment-icon--gift-card.payment-method-list__item-icon').css('background-image', 'url(//cdn.shopify.com/s/files/1/0076/0519/0767/files/Financing.png?20608),none');
                $('.payment-icon--gift-card.payment-method-list__item-icon').next().html("Financing Applied");

                //Rebuild the contact information area
                $("h3:contains('Shipping address')").html("Service Address");
                $( "h3:contains('Shipping method')" ).hide();
                $( "p:contains('Standard Shipping')" ).hide();


                $('.contact-information').hide();
                $('div.step').slideDown(200);
                $('.layoutContentPlaceholder').remove();
                
            }

                  // Check if finance application
            const financeElement = document.querySelector('tr.product .product__description__property ');
            if (financeElement !== null) {
              const isFinanceDownPaymentDraft = financeElement.innerHTML.includes('Finance Application ID:');

              // Check if payment page
              const urlParams = new URLSearchParams(window.location.search);
              const currentStep = urlParams.get('step');

              if (currentStep === 'contact_information' || currentStep === null) {
                window.location.href = `${window.location.origin}${window.location.pathname}?step=payment_method`;
                return;
              }

              try {
                document.querySelector('.main_nav ul.menu li.delivery-pickup').remove();
              } catch {}
              try {
                document.querySelector('.main_nav ul.menu li.cart').remove();
              } catch {}
              try {
                document.querySelector('.step__footer a.step__footer__previous-link').remove();
              } catch {}
              try {
                document.querySelector('.main__content .customer-details .row.delivery-details').remove();
              } catch {}

              console.log(transitionToCredit)
              transitionToCredit('payment-start');
            }

            // Show body
            document.body.style.display = 'block';

    }
        
});